export const readingLevelFilterContainer = {
  display: "flex",
  flexDirection: "column" as const,
  justifyContent: "space-between",
  alignItems: "start",
  width: "500px",
  margin: "0",
};

export const filterContainerCss = {
  marginBottom: "32px",
};
